import { makeAutoObservable, reaction } from 'mobx';
import { checkHashStore } from '../../../store/checkHashStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { freeBetStore } from '../../../store/freeBetStore';

class PowerOfGodsBetsStore {
  oddsDic = null;

  winAmount = 0;

  lastResults = [];

  isBetsClosed = false;

  isAllowToChangeBetAmount = true;

  isAllowIncrementBetValue = true;

  isAllowDecrementBetValue = true;

  constructor() {
    makeAutoObservable(this);

    reaction(
      () => this.isBetsClosed,
      (value) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        setIsAllowedChangeCurrency(!value);
        if (freeBetStore.currentFreeBet && !freeBetStore.currentFreeBet.remainingCount && !value) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );
  }

  updateResultSaltAndKey({ salt, key, hash, newHash, odd, id, riskType, sectorCountType }) {
    checkHashStore.setLastRoundInfo({ salt, key, hash });
    checkHashStore.setNextRoundHash(newHash);
    checkHashStore.setLastRoundResult({ odd, id, riskType, sectorCountType });
  }

  setWinAmount(amount) {
    this.winAmount = amount;
  }

  setIsAllowToChangeBetAmount(isAllow) {
    this.isAllowToChangeBetAmount = isAllow;
  }

  setLastResults() {}

  updateLastResults() {}

  setIsBetsClosed(bool) {
    this.isBetsClosed = bool;
    this.isAllowToChangeBetAmount = !bool;
  }

  resetBetStore() {}
}

export const powerOfGodsBetsStore = new PowerOfGodsBetsStore();
